const navigatorLang = () => (navigator.language.toLowerCase().split('-')[0]);

const getLanguage = () => {
  const lang = localStorage.getItem('lang');
  if (lang) {
    return lang;
  }
  return navigatorLang();
};

export { navigatorLang };
export default getLanguage;
